/**
 * @desc 财务画像-基础信息-资产负债构成
 */
import React, { PureComponent } from 'react';
import style from '../common/assetLiabilities.scss';
import { Row, Col, Spin } from 'antd';
import GroupBox from '../../../common/groupBox/GroupBox';
import AssetLiabPie from '../common/AssetLiabPie';
import { assetLiabilit } from '../../../../services/financialPicture/baseInfo';
import { commonRequest } from '../../common/commons';
import { isEmpty, isNotEmpty } from '../../../../utils/util';

export default class AssetLiabilities extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            allBarData: []
        };
    }

    componentDidMount() {
        this.assetLiabilitPort();
    }

    assetLiabilitPort = () => {
        this.setState({
            loading: true
        });
        assetLiabilit(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                allBarData: this.allDataFn(data)
            });
        }).catch(() => {
            this.setState({
                loading: false,
                allBarData: []
            });
        });
    };

    allDataFn = (data) => {
        let allData = [];
        allData.push(
            this.clearValueOfNuLL(data.circulatasset, '流动资产构成', 1),
            this.clearValueOfNuLL(data.fixedasset, '非流动资产构成', 2),
            this.clearValueOfNuLL(data.circulatdebt, '流动负债构成', 3),
            this.clearValueOfNuLL(data.fixeddebt, '非流动负债构成', 4)
        );
        return allData;
    };

    // 当图表数据为null时, 返回[]
    clearValueOfNuLL = (data, title, id) => {
        if (isEmpty(data)) {
            return [];
        }
        let newData = [];
        data.forEach(item => {
            if (isNotEmpty(item.value) && item.value !== 0) {
                newData.push(item);
            }
        });
        return { value: newData, title: title, id: id };
    }

    render() {
        const { loading, allBarData } = this.state;
        return (
            <GroupBox id="asset-liabilities" title="资产负债构成">
                <div className={style.assetliabilities}>
                    <Row>
                        {
                            loading ? <Spin title="数据加载中..." /> :
                                allBarData.map(item => (
                                    <div key={item.id} className={style.subTitle}>
                                        <Col span={12}>
                                            <p className="wrap-title">-{item.title}-</p>
                                            <AssetLiabPie
                                                pieData={item.value}
                                                title={item.title}
                                            />
                                        </Col>
                                    </div>
                                ))
                        }
                    </Row>
                </div>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/AssetLiabilities.jsx